function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import ReactDOM from "react-dom";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { shadowDepth3 } from "../../utils/shadows"; //#region StyledComponents

var TooltipWindow = styled.div.attrs({
  style: function style(_ref) {
    var left = _ref.left,
      top = _ref.top;
    return {
      left: "".concat(left, "px"),
      top: "".concat(top, "px")
    };
  }
}).withConfig({
  displayName: "TooltipContent__TooltipWindow"
})(["position:absolute;max-width:260px;max-height:180px;pointer-events:none;z-index:100;"]);
var topMixin = css(["bottom:100%;&:before{top:100%;border-top:", "px solid black;}"], function (props) {
  return props.arrowSize;
});
var bottomMixin = css(["top:100%;&:before{bottom:100%;border-bottom:", "px solid black;}"], function (props) {
  return props.arrowSize;
});
var leftMixin = css(["right:0px;&:before{right:", "px;border-left:", "px solid transparent;}"], function (props) {
  return props.arrowOffset;
}, function (props) {
  return props.arrowSize;
});
var rightMixin = css(["&:before{left:", "px;border-right:", "px solid transparent;}"], function (props) {
  return props.arrowOffset;
}, function (props) {
  return props.arrowSize;
});
var TooltipContainer = styled.div.withConfig({
  displayName: "TooltipContent__TooltipContainer"
})(["background-color:black;border-radius:5px;color:white;padding:8px;pointer-events:none;user-select:none;font-size:14px;line-height:1.3em;font-weight:300;text-transform:none;", " opacity:", ";transition:opacity ", "ms ease;white-space:normal;&:before{content:\"\";position:absolute;width:0;height:0;}", ";", ";"], shadowDepth3, function (props) {
  return props.active ? 1 : 0;
}, function (props) {
  return props.transitionDuration;
}, function (props) {
  return props.horizontal === "left" ? leftMixin : rightMixin;
}, function (props) {
  return props.vertical === "top" ? topMixin : bottomMixin;
});
TooltipContainer.propTypes = {
  horizontal: PropTypes.oneOf(["left", "right"]),
  vertical: PropTypes.oneOf(["top", "bottom"]),
  active: PropTypes.bool,
  arrowSize: PropTypes.number,
  arrowOffset: PropTypes.number,
  transitionDuration: PropTypes.number
}; //#endregion

var coordinates = PropTypes.shape({
  x: PropTypes.number,
  y: PropTypes.number
});
var TooltipContent = /*#__PURE__*/
function (_PureComponent) {
  _inherits(TooltipContent, _PureComponent);
  function TooltipContent() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, TooltipContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TooltipContent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTipCoordinates", function (position) {
      return _this.props.tipPosition.all || _this.props.tipPosition[position];
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tooltipPositionWouldExceedWidth", function (tooltip) {
      return _this.getTipCoordinates("center").x + tooltip.width - _this.props.arrowOffset >= window.innerWidth;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tooltipPositionWouldExceedHeight", function (tooltip) {
      return _this.getTipCoordinates("center").y + tooltip.height + _this.props.arrowSize + _this.props.tipOffset >= window.innerHeight;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTooltipHorizontalPosition", function (tooltip) {
      return _this.tooltipPositionWouldExceedWidth(tooltip) ? "left" : "right";
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTooltipVerticalPosition", function (tooltip) {
      return _this.tooltipPositionWouldExceedHeight(tooltip) ? "top" : "bottom";
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTooltipRelativePosition", function (tooltip) {
      return {
        horizontal: _this.props.forcedHorizontal || _this.getTooltipHorizontalPosition(tooltip),
        vertical: _this.props.forcedVertical || _this.getTooltipVerticalPosition(tooltip)
      };
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tipXForPosition", {
      left: function left(tooltip) {
        return _this.getTipCoordinates("left").x - tooltip.width + _this.props.arrowOffset;
      },
      right: function right() {
        return _this.getTipCoordinates("right").x - _this.props.arrowOffset;
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tipYForPosition", {
      top: function top(tooltip) {
        return _this.getTipCoordinates("top").y - tooltip.height - _this.props.arrowSize;
      },
      bottom: function bottom() {
        return _this.getTipCoordinates("bottom").y + _this.props.arrowSize + _this.props.tipOffset;
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTipForRelativePosition", function (horizontal, vertical, tooltip) {
      return {
        arrowTipX: _this.tipXForPosition[horizontal](tooltip),
        arrowTipY: _this.tipYForPosition[vertical](tooltip)
      };
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clampArrowTipX", function (arrowTipX, offset) {
      return Math.max(Math.min(arrowTipX, window.innerWidth - offset), 0);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tooltipRef", function (tooltip) {
      if (tooltip) _this.tooltipElement = tooltip;
    });
    return _this;
  }
  _createClass(TooltipContent, [{
    key: "getPosition",
    value: function getPosition() {
      if (!this.tooltipElement) {
        // Set initial position to the top of the screen so the element renders its own width and height correctly.
        return {
          left: 0,
          top: 0,
          vertical: "bottom",
          horizontal: "right"
        };
      }
      var tooltip = this.tooltipElement.getBoundingClientRect();
      var _this$getTooltipRelat = this.getTooltipRelativePosition(tooltip),
        horizontal = _this$getTooltipRelat.horizontal,
        vertical = _this$getTooltipRelat.vertical;
      var _this$getTipForRelati = this.getTipForRelativePosition(horizontal, vertical, tooltip),
        arrowTipX = _this$getTipForRelati.arrowTipX,
        arrowTipY = _this$getTipForRelati.arrowTipY; // Since tooltip size exceeds the arrow horizontally by `${arrowOffset}px`, we clamp it so it doesn't go out the window.

      var left = this.clampArrowTipX(arrowTipX, tooltip.width);
      var top = arrowTipY;
      return {
        left: left,
        top: top,
        vertical: vertical,
        horizontal: horizontal
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        transition = _this$props.transition,
        arrowSize = _this$props.arrowSize,
        arrowOffset = _this$props.arrowOffset,
        transitionDuration = _this$props.transitionDuration;
      var position = this.getPosition();
      return ReactDOM.createPortal(React.createElement(TooltipWindow, {
        left: position.left,
        top: position.top
      }, React.createElement(TooltipContainer, {
        vertical: position.vertical,
        horizontal: position.horizontal,
        active: !transition,
        innerRef: this.tooltipRef,
        arrowSize: arrowSize,
        arrowOffset: arrowOffset,
        transitionDuration: transitionDuration
      }, children)), this.props.tooltipRootDOM);
    }
  }]);
  return TooltipContent;
}(PureComponent);
_defineProperty(TooltipContent, "propTypes", {
  // HTML root element where you want the tooltip to be rendered
  tooltipRootDOM: PropTypes.instanceOf(Element).isRequired,
  children: PropTypes.node,
  // Where the component will render the tip and build the whole tooltip from
  tipPosition: PropTypes.shape({
    all: coordinates,
    center: coordinates,
    top: coordinates,
    bottom: coordinates,
    left: coordinates,
    right: coordinates
  }),
  transition: PropTypes.bool,
  transitionDuration: PropTypes.number,
  tipOffset: PropTypes.number,
  arrowOffset: PropTypes.number,
  arrowSize: PropTypes.number,
  forcedHorizontal: PropTypes.oneOf(["left", "right"]),
  forcedVertical: PropTypes.oneOf(["top", "bottom"])
});
export { TooltipContent as default };